import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"

const RecentImageBlob = () => {
  const data = useStaticQuery(graphql`
    query imageListQuery {
        photos: allMdx(
          filter: {frontmatter: {type: {eq: "Photo"}}, slug: {regex: "^/photo\\/.*/"}}
          limit: 10
          sort: {order: DESC, fields: frontmatter___date}
        ) {
          photoEdges: edges {
            node {
              id
              slug
              frontmatter {
                title
              }
              image {
                id
                key
                maxSize
                size
                srcSet
                srcPath
                width
                height
                sqSrcSet
                srcSet
              }
            }
          }
        }
      }
  `)

  const Photos = data.photos.photoEdges.map(edge => {
    return (
      <figure className="image sqimg" key={edge.node.slug}>
      <Link to={"/" + edge.node.slug}><img srcSet={edge.node.image.sqSrcSet} alt={edge.node.frontmatter.title}/></Link>
      </figure>
    );
  })
  return (Photos);
}

export default RecentImageBlob 